import { useMemo } from "react";
import { useTranslation } from "react-i18next";

export const useCompanyInformationConfig = () => {
    const { t } = useTranslation();

    return useMemo(() => [
        { name: t("companies"), key: "companies" },
        { name: t("managers"), key: "supervisors" },
        { name: t("primary-manager"), key: "primarySupervisor" },
        { name: t("primary-location"), key: "primaryLocation" },
        { name: t("other-locations"), key: "otherLocations" },
        { name: t("pay-group"), key: "payGroup" },
        { name: t("hourly-or-salary"), key: "salaryOrHourly" },
    ], [t]);
}
